import { FieldTypes } from "./field.types";
import { MetaDataStore } from "./datastore";
import { FormModel } from "./form.model";
import { registerModels as registerBaseModels } from "./index";
import { BaseModel } from "./base.model";

export function CaseMetadataWrapper(jsonData, id = jsonData["Root"]) {
  registerModels();
  let kind = jsonData[id].Kind;
  let dynamicClass = CaseModel.getMetadata(kind);
  let ds = new MetaDataStore(jsonData);
  let modelIns = new dynamicClass(ds, id, dynamicClass);
  ds.cache.set(id, modelIns);
  return modelIns;
}

function registerModels() {
  registerBaseModels();
  registerCaseModels();
}

export function registerCaseModels() {
  CaseModel.registerModel(CaseModel, "Model");
}

export class CaseModel extends FormModel {}

export function CasePermissionMetadataWrapper(jsonData, id = jsonData["Root"]) {
  register();
  let kind = jsonData[id].Kind;
  let dynamicClass = CasePermission.getMetadata(kind);
  let ds = new MetaDataStore(jsonData);
  let modelIns = new dynamicClass(ds, id, dynamicClass);
  ds.cache.set(id, modelIns);
  return modelIns;
}

function register() {
  registerBaseModels();
  registerCasePermissionModels();
}

export function registerCasePermissionModels() {
  CasePermission.registerModel(CasePermission, "CasePermission");
  CasePermission.registerModel(Permission);
}

export class CasePermission extends BaseModel {
  getPermissions() {
    return this.getList("CasePermission", "Permission");
  }
}
CasePermission.setOneToManyList(["CasePermission::Permission"]);

CasePermission.setFieldTypes({
  Name: FieldTypes.string.isRequired,
  Type: FieldTypes.string,
  FlowType: FieldTypes.string
});
export class Permission extends BaseModel {}

Permission.setFieldTypes({
  CasePermission: FieldTypes.string,
  Column: FieldTypes.string,
  Permission: FieldTypes.string,
  Status: FieldTypes.string
});

Permission.setManyToOneList(["CasePermission::CasePermission"]);
